export default {"src":"/newStatic/_next/static/media/bellIcon_solid.952ef92c.svg","height":15,"width":12};